
import { Injectable } from '@angular/core';
import { Curriculum, Objective, } from '../../_models/index';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class LmsService {
    private static _isCurriculumFormOpened = false;
    private static _isCurriculumHasCurriculumItems = true;
    static curriculumChanged$ = new Subject();
    static curriculumItemChanged$ = new Subject();
    static curriculumItemUpdated$ = new Subject();
    static curriculumItemDeleted$ = new Subject();
    static curriculumItemResourceChanged$ = new Subject();
    static curriculumItemResourceUpdated$ = new Subject();
    static curriculumItemResourceDeleted$ = new Subject();
    static objectivesChanged$ = new Subject();
    static objectiveDeleted$ = new Subject<number>();
    static objectiveUpdated$ = new Subject<Objective>();

    static get isCurriculumFormOpened(): boolean {
        return LmsService._isCurriculumFormOpened;
    }
    static set isCurriculumFormOpened(value: boolean) {
        LmsService._isCurriculumFormOpened = value;
    }

    static get isCurriculumHasCurriculumItems(): boolean {
        return LmsService._isCurriculumHasCurriculumItems;
    }
    static set isCurriculumHasCurriculumItems(value: boolean) {
        LmsService._isCurriculumHasCurriculumItems = value;
    }
}
